import React from 'react'
import { Elements, RecurlyProvider } from '@recurly/react-recurly'
import { Subscription } from '../subscription/subscription'
import { useStyles } from './recurly-container.styles'

export const RecurlyContainer = () => {
  const styles = useStyles()

  return (
    <RecurlyProvider publicKey={process.env.RECURLY_PUBLIC_KEY!}>
      <Elements>
        <div className={styles.mainContainer}>
          <Subscription />
        </div>
      </Elements>
    </RecurlyProvider>
  )
}

export type RecurlyContainerType = typeof RecurlyContainer
